export const ACCESS_TOKEN_DATA_KEY = "__waa_pwa_access_token_data__";
export const ACCEPTED_TERMS = "__waa_pwa_accepted_terms__"
export const ACCEPTED_PRIVACY = "__waa_pwa_accepted_privacy__"
export const ACCEPTED_ALL_TERMS = "__waa_pwa_accepted_all_terms__"
export const USER_EMAIL = "__waa_pwa_user_email__"
export const USER_EMAIL_ADD = "__waa_pwa_user_email_add__"
export const USER_ID_DATA_KEY = "__waa_pwa_user_id__"
export const EVENTS_PAGE = "__waa_event_page__"
export const APP_VERSION = "__waa_app_version__"

export const ACCEPTED = "accepted";
export const COMPLETED = "completed"
export const VISITED = "visited";

export const ASSIST_CLICK = "assist_click";

export const COMPLETED_ASSIST_PROFILE = "__assist_completed_profile_key__"
export const ASSIST_RESTRICTION = "__assist_restriction_key__"
export const NO_RESPONSE_EMERGENCY_ALERT = 0;

export const RESTRICTION_MESSAGE = "Kindly contact your HR to get access to ASSiST.";

//export const AYALA_NEWS_RSS = 'https://dev-waa.pantheonsite.io/?call_custom_simple_rss=1&csrp_post_status=publish&csrp_thumbnail_size=full&csrp_show_thumbnail=1&csrp_show_meta=1&csrp_posts_per_page=5'
export const AYALA_NEWS_RSS = 'https://weareayala.com/?call_custom_simple_rss=1&csrp_post_status=publish&csrp_thumbnail_size=full&csrp_show_thumbnail=1&csrp_show_meta=1&csrp_posts_per_page=5'
export const ACENTIVES_URL = "https://acentives.com/member-login/?code=weareayala";
export const ACENTIVES_API = "https://acentivesprod.herokuapp.com/dealsWeb";
export const ACENTIVES_DEALS_DATA_KEY = "__waa_acentives_deals_key__";

export const AYALA_NEWS_URL = "https://dev-waa.pantheonsite.io/";
export const HEALTHNOW_URL = "https://www.healthnow.ph/";

export const WAA_READ_ITEMS = "__waa_read_items_key__";

export const REFERRER_SITE = "referrerSite" 
//prod
export const GOOGLE_ANALYTICS_TRACKING_ID = "G-JYFECWP3EE"
//dev uat
//export const GOOGLE_ANALYTICS_TRACKING_ID = "G-GRNXFCJMBR"

export const DRAFT = 1;
export const PUBLISHED = 2;

